import React from 'react'
import AdminBanner from './AdminBanner'
import LineCharts from '../../Main/LineCharts'

const AdminDashboard = () => {
    return (
        <>
            <AdminBanner />
            <LineCharts />
        </>
    )
}

export default AdminDashboard